export function hasShippableItems(expressModel) {
  return expressModel.lineItems.some(lineItem => lineItem.shippable);
}
//# sourceMappingURL=hasShippableItems.js.map